import { createUseStyles } from "react-jss";
import { foregroundColor, darken, alpha, getSpacing } from "../../theme/Mixins";

export default createUseStyles({
    container: {
        composes: "drag-drop",
        position: "relative",
        userSelect: "none",
        margin: "auto",
        maxWidth: 600,
        marginTop: ({ theme }) => getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents),
    },
    bucket: {
        composes: "drag-drop__list",
        border: "1px solid #999",
        position: "absolute",
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 50),
    },
    bucketOrigin: {
        composes: "drag-drop__list--origin",
        border: ({ theme }) => [
            [Math.max(theme.BorderWidth, 1), "solid", theme.ControlBorderColor],
        ],
    },
    bucketOriginNoDrag: {
        composes: "drag-drop__list--origin--no-drag",
        cursor: "not-allowed",
    },
    bucketDestination: {
        composes: "drag-drop__list--destination",
        background: ({ theme }) =>
            `${alpha(theme.ControlBackground, theme.ControlAlpha)} 0% 0% no-repeat padding-box`,
        border: ({ theme }) => [[theme.BorderWidth, "solid", theme.ControlBorderColor]],
    },
    card: {
        composes: "drag-drop__choice",
        backgroundColor: ({ theme }) => theme.SecondaryColor,
        border: ({ theme }) => [
            [
                Math.max(theme.BorderWidth, 1),
                "solid",
                darken(theme.SecondaryColor, theme.BorderValue),
            ],
        ],
        borderRadius: ({ theme }) => theme.BorderRadius,
        color: ({ theme }) => foregroundColor(theme, theme.SecondaryColor),
        position: "absolute",
        padding: 8,
        textAlign: "center",
        fontWeight: "bolder",
        touchAction: "none",
        boxSizing: "border-box",
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: "grab",

        "&:active": {
            cursor: "grabbing",
        },
    },
    cardNoDrag: {
        composes: "drag-drop__choice--no-drag",
        pointerEvents: "none",
        cursor: "not-allowed",
        backgroundColor: ({ theme }) => darken(theme.SecondaryColor),
        border: ({ theme }) => [
            [
                Math.max(theme.BorderWidth, 1),
                "solid",
                darken(theme.SecondaryColor, theme.BorderValue),
            ],
        ],
        borderRadius: ({ theme }) => theme.BorderRadius,
        color: ({ theme }) => foregroundColor(theme, theme.SecondaryColor),
        position: "absolute",
        padding: 8,
        textAlign: "center",
        fontWeight: "bolder",
        boxSizing: "border-box",
        backgroundSize: "cover",
        backgroundPosition: "center",

        "&:active": {
            cursor: "grabbing",
        },
    },
});
